import AdminApi from '../stylemix-vue-admin/plugins/api'

export default class TransferFixedRidePricesApi extends AdminApi {
  constructor(parameters = {}) {
    super('company/airport-pricing/fixed-rides', parameters)
  }
}
